import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import WebLayout from "layouts/WebLayout";
import PolicysLayout from "layouts/policysLayout";

// Authentication Routes
const Login = lazy(() => import("./views/auth/signIn"));
const Register = lazy(() => import("./views/auth/signUp"));
const Home = lazy(() => import("./views/web/home"));
const Aboutus = lazy(() => import("./views/web/about-us"));
const OtpVerification = lazy(() => import("./views/auth/otpVerification"));
const Mpin = lazy(() => import("./views/auth/mpin"));
const ForgotPassword = lazy(() => import("./views/auth/forgotPassword/forgotPassword"));
const SetPassword = lazy(() => import("./views/auth/forgotPassword/setPassword"));
const ProductDetails = lazy(() => import("./views/web/product_details"));

// Puplic Routes
const Terms = lazy(() => import("./views/web/terms-and-condition"));
const Privacy = lazy(() => import("./views/web/privacy-policy"));
const Shipping = lazy(() => import("./views/web/shipping-policy"));
const Refund = lazy(() => import("./views/web/refund"));

function App() {
  return (
    <Suspense
      fallback={<div ><h1>Loading.....</h1></div>}>
      <Routes>
        <Route element={<WebLayout />}>
          <Route exact path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/otp-verification" element={<OtpVerification />} />
          <Route path="/create-mpin" element={<Mpin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/product-details" element={<ProductDetails />} />
        </Route>


        <Route element={<PolicysLayout />}>
          <Route path="/terms-and-condition" element={<Terms />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/shipping-policy" element={<Shipping />} />
          <Route path="/cancellation-and-refund" element={<Refund />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
